<template>
  <v-container>
    <v-data-table :headers="headers" :items="items" class="elevation-0" disable-pagination hide-default-footer>
      <template slot="item" slot-scope="props">
        <tr>
          <td style="text-align: left">
            <editable-input v-model="props.item.task" :item-id="props.item.id"></editable-input>
          </td>
          <td style="text-align: left">{{ props.item.activityTypeDescription }}</td>
          <td style="text-align: left">
            {{ props.item.cableDescription }}
          </td>
          <td style="text-align: left">{{ props.item.previousMeters }}</td>
          <td style="text-align: left">{{ props.item.metersToday }}</td>
          <td style="text-align: left">{{ props.item.cumulativeTotal }}</td>
        </tr>
      </template>
    </v-data-table>
    <v-divider class="mb-3"></v-divider>
  </v-container>
</template>

<script>
import { mapMutations, mapGetters, mapActions } from "vuex";

export default {
  name: "progress-analysis",
  data() {
    return {
      headers: [
        {
          text: this.$t("vessel.task"),
          align: "start",
          value: "task",
        },
        { text: this.$t("vessel.operation"), value: "activtyTypeId" },
        { text: this.$t("column.cable"), mvalue: "cableDescription" },
        { text: this.$t("vessel.pm"), value: "previousMeters" },
        { text: this.$t("vessel.metersToday"), value: "metersToday" },
        { text: this.$t("vessel.cumulativeTotal"), value: "cumulativeTotal" },
      ],
      currentMainDprId: null,
      currentPVId: null,
    };
  },
  computed: {
    ...mapGetters(["mv_dprData/getDprPVId", "mv_dprData/getCurrentDprMainId", "mv_progressAnalysis/getProgressAnalysis"]),
    items() {
      return this["mv_progressAnalysis/getProgressAnalysis"];
    },
  },
  created() {
    this.currentMainDprId = this.$route.params.dprMainId;
    this.currentPVId = this.$route.params.pvId;
    this["mv_progressAnalysis/fetchProgressAnalysisByDprId"](this.currentMainDprId);
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.mHideLongLoader();
    });
  },
  methods: {
    ...mapMutations(["mHideLongLoader"]),
    ...mapActions(["mv_progressAnalysis/fetchProgressAnalysisByDprId"]),
  },
};
</script>
<style scoped>
.container {
  max-width: 95%;
}
</style>
